export default __webpack_public_path__ + "static/media/gallery-6.4376d673.jpg";